import { render, staticRenderFns } from "./customListComponent.vue?vue&type=template&id=6aaadb34&"
import script from "./customListComponent.vue?vue&type=script&lang=js&"
export * from "./customListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports